module.exports = __webpack_public_path__ + "img/SWP_Hammer_2H_03 (2).f19410ac.png";